module.exports = __webpack_public_path__ + "static/assets/0b0662d4fa04471ec5b47ffd617bf5d3.png";